module.exports = __webpack_public_path__ + "static/media/server.0c0b1681.svg";